module.exports = __webpack_public_path__ + "img/mini-card.ddb6cf4a.svg";